import { Injectable } from '@angular/core';
import { CommonService } from './CommonService';
import { ILoggerModel } from '../model/logger.model';
import { AppGlobals } from './app.global';
import { NgxSpinnerService } from 'ngx-spinner';
import swal from 'sweetalert2';
import { PopupMessageService } from './popupMessageService';
import { WebService } from './web.service';

@Injectable()
export class LoggerService {
  private loginUser;

  constructor(protected _CommonService: CommonService, private appGlobals: AppGlobals, private spinner: NgxSpinnerService, private popupMessageService: PopupMessageService, private webService: WebService) {

  }

  IsDeleted = false;


  // for remove spaces between two words only one space allowed
  validate(x) {
    return x ? x.replace(/ {2,}/g, ' ').trim() : '';
  }

  // for show and dismiss loader
  showloader() {
    this.spinner.show();
  }

  closeloader() {
    this.spinner.hide();
  }


  // for get loogerdetail 
  GetLoggerDetails(): ILoggerModel 
  {
    let objLoggerModel: ILoggerModel;

    objLoggerModel =
      ({
        LoginSessionId: 0,
        EmailId: '',
        IPAddress: '',
        MACAddress: '',
        ModuleRoute: ''
      })

      if(this.appGlobals.IsMow == 'false')
      {
        this.loginUser = this.appGlobals.GetLoggedUserDetail();
        objLoggerModel.LoginSessionId = this.loginUser.Id;
        objLoggerModel.EmailId = this.loginUser.Email;
      }

    this._CommonService.getIpAddress().subscribe((response: any) => {
      objLoggerModel.IPAddress = response.ip
    });

    return objLoggerModel;

  }


  // for common delete popup  
  delete(active, url, object) 
  {

    let confirmButtonText = '';

    if (active) 
    {
      confirmButtonText = 'Yes, delete it!';
    }
    else 
    {
      confirmButtonText = 'Yes, undo delete!';
    }

    swal
      ({
        title: 'Are you sure?',
        text: 'You want be able to revert',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmButtonText,
        allowOutsideClick: false
      }).then(result => {
        if (result.value == true) 
        {
          this.showloader();
          this.webService.Delete(object, url).then((response: any) => 
          {
            this.closeloader();
            if (response.Status == true) 
            {
              this.popupMessageService.openSuccessSwal('Deleted', response.Message);
            }
            else 
            {
              this.popupMessageService.openWarningSwal('Fail', 'Record not deleted!');
            }
          });
        }
      })
    
  }

}


// WEBPACK FOOTER //
// ./src/app/service/logger.service.ts